module.exports = __webpack_public_path__ + "img/12_89.ca470887.png";